/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Email_LabelInputs */



/**
* | output |
* | --- |
* | "Email (optional)" |
*
* @param {User_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_email_label = /** @type {((inputs?: User_Email_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Email_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("E-mail (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email (facoltativa)")
	return /** @type {LocalizedString} */ ("Email (optional)")
});